import type { FC } from 'react';
import { SalaryComparison } from '@reverse-hr/design-system';
import type { TGlobalCompensationTotalProps } from '@components/Organisms/GlobalCompensation/GlobalCompensation.types';
import { useStoreState } from 'easy-peasy';
import {
  jobActualStoreSelector,
  selectorJobIsReverseMarketing,
} from '@model/Job/Job.selectors';
import { getValueInThousands } from '@components/Organisms/GlobalCompensation/_helpers/global-compensation';
import { useTranslation } from 'react-i18next';

export const GlobalCompensationTotal: FC<TGlobalCompensationTotalProps> = ({
  contractLevel,
  isDesired,
  isEstimated,
  isFreelancer,
  total,
}) => {
  const { t } = useTranslation('', {
    keyPrefix: 'globalCompensation.compensationPackage',
  });

  const jobState = useStoreState(jobActualStoreSelector);
  const isJobReverseMarketing = useStoreState(selectorJobIsReverseMarketing);

  const displayTotal = getValueInThousands(total);
  const displayMinimum = getValueInThousands(jobState?.minimumSalary || 0);
  const displayMaximum = getValueInThousands(jobState?.maximumSalary || 0);

  const displayedContractLevel =
    isFreelancer && !isDesired ? t('freelancerContractLevel') : contractLevel;

  return (
    <div className="c-global-compensation__total">
      <p className="c-global-compensation__heading">
        {t('total', {
          context: isFreelancer && !isDesired ? 'estimated' : null,
        })}

        {isJobReverseMarketing && (
          <span className="c-global-compensation__heading-total">
            ~{displayTotal}K
          </span>
        )}
      </p>

      {isJobReverseMarketing ? null : (
        <SalaryComparison
          currentValue={displayTotal || null}
          isEstimated={isEstimated}
          maxValue={displayMaximum}
          minValue={displayMinimum}
        />
      )}

      <p className="c-global-compensation__contract-level">
        {displayedContractLevel ?? ''}
      </p>
    </div>
  );
};
